/* 決済方法 */
export default {
  // 現地決済
  LOCALLY: '10',
  // 事前決済
  ADVANCE: '20',
  // 選択可能
  SELECTABLE: '30',
}